/** Request timeout in milliseconds for API clients. */
export const API_TIMEOUT = 30_000;

export const HIREOLOGY_API_URL = process.env.NEXT_PUBLIC_HIREOLOGY_API_URL;
export const HIREOLOGY_API_URL_V3 =
  process.env.NEXT_PUBLIC_HIREOLOGY_API_URL_V3;
export const HIREOLOGY_APP_URL = process.env.NEXT_PUBLIC_HIREOLOGY_APP_URL;
export const NEXTJS_BASEPATH = '/ui';
export const REFERRALS_APP_URL = process.env.NEXT_PUBLIC_REFERRALS_APP_URL;
export const REFERRALS_API_URL = process.env
  .NEXT_PUBLIC_REFERRALS_API_URL as string;
export const GOOGLE_PLACES_API_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY;
